/* eslint-disable no-unused-vars */
import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SetupWizard from './shared/components/setup/SetupWizard';
import WelcomeLoginPage from './shared/components/setup/WelcomeLoginPage';
import ForgotPasswordPage from './shared/components/setup/ForgotPasswordPage';
import ResetPasswordPage from './shared/components/setup/ResetPasswordPage';
import { SetupProvider } from './core/contexts/SetupContext';
import { LayoutProvider } from './core/contexts/LayoutContext';
import { AppContent } from './AppContent';
import OnlineDemoLeadGate from './online-demo/OnlineDemoLeadGate';
import { isCloudDemoRuntime } from './shared/utils/publicDemoRuntime';
import { isSaudiBrand } from './products/saudi/utils/isSaudiBrand';
import QawaemWelcomeLoginPage from './products/saudi/pages/QawaemWelcomeLoginPage';
import QawaemSetupWizard from './products/saudi/pages/QawaemSetupWizard';
import { isQawaemDirectAccess } from './products/saudi/utils/isQawaemDirectAccess';

const IS_CLOUD_DEMO = isCloudDemoRuntime();
const IS_SAUDI = isSaudiBrand();
const SKIP_AUTH = isQawaemDirectAccess();
const AppHomeRedirect = () => <Navigate to="/dashboard" replace />;

function App() {
  return (
    <SetupProvider>
      <LayoutProvider>
        {IS_CLOUD_DEMO ? (
          <OnlineDemoLeadGate />
        ) : (
          <Router>
            <Routes>
              <Route
                path="/setup"
                element={SKIP_AUTH ? <AppHomeRedirect /> : IS_SAUDI ? <QawaemSetupWizard /> : <SetupWizard />}
              />
              <Route
                path="/login"
                element={SKIP_AUTH ? <AppHomeRedirect /> : IS_SAUDI ? <QawaemWelcomeLoginPage /> : <WelcomeLoginPage />}
              />
              <Route path="/forgot-password" element={SKIP_AUTH ? <AppHomeRedirect /> : <ForgotPasswordPage />} />
              <Route path="/reset-password" element={SKIP_AUTH ? <AppHomeRedirect /> : <ResetPasswordPage />} />
              <Route path="/*" element={<AppContent />} />
            </Routes>
          </Router>
        )}
      </LayoutProvider>
    </SetupProvider>
  );
}

export default App;
